<div class="contract-wrapper">
  <table style="width: 100%;" border="0px">
    <tbody id="fordImage">
      <tr>
        <td style="text-align: left;">
          <img style="width: 380px; height: 80px;"
            src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="">
        </td>
      </tr>
    </tbody>
  </table>
  <div class="client-data-field-text title-top title-top--centered">
    <b>
      TERMO DE CONTRATAÇÃO - SEGURO GARANTIA ESTENDIDA REDUZIDA
    </b>
  </div>
  <br>
  <span class="client-data-field-text">
    <b><u>Dados do Seguro</u></b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b>Extensão de Garantia ({{contractSignature.distance}} km /
      {{contractSignature.extendedWarranty}} anos)</b>
    <br>
    <br>
    Início e término de vigência da cobertura: Conforme informação do bilhete de seguro a ser emitido. O
    bilhete
    somente será emitido, e enviado por e-mail automaticamente ao cliente, após a disponibilização do
    chassi
    do veículo.
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b><u>Dados do Veículo:</u></b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <u>Modelo:</u> {{ contractSignature.vehicleLine }}
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <u>Ano:</u> {{ contractSignature.modelYear }}
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <u>Odômetro:</u> {{ contractSignature.odometerStart }}
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b>Notas:</b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    1) A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias
    corridos, com a
    devolução integral do valor pago, a contar da assinatura da proposta, no caso de contratação por
    bilhete
    individual, ou da
    emissão do bilhete, no caso de contratação por bilhete, ou do efetivo pagamento do prêmio, o que
    ocorrer
    por último. É
    proibido condicionar desconto no preço do bem à aquisição do seguro.
    <br>
    2) No caso de pagamento de prêmio fracionado, considera-se o pagamento da primeira parcela como o
    efetivo pagamento.
  </span>
  <br><br>
  <span class="client-data-field-text">
    Garantido por AIG Seguros Brasil S/A. CNPJ 33.040.981/0001-50 | Central de Atendimento AIG 24 horas:
    0800 726 6130 /
    Atendimento AIG a Deficientes Auditivos: 0800 724 0149 | Ouvidoria (2ª a 6ª-feira, das 9h às 18h):
    0800
    724 02 19 /
    Ouvidoria - Atendimento a Deficientes Auditivos e de fala (2ª a 6ª-feira, das 9h às 18h): 0800 200
    1244.
    O registro deste
    plano na SUSEP não implica, por parte da Autarquia, incentivo ou recomendação a sua comercialização.
    Consulte sempre a
    versão das Condições Gerais do produto específico para informações completas. PROCESSO SUSEP – nº
    15414.649128/2023-86.
    <br>
    Representante de Seguros: Ford Motor Company Brasil Ltda. CNPJ 03.470.727/0004-73.
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b><u>Declaração do Segurado</u></b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    Confirmo que tomei ciência das Condições Gerais do produto e que recebi o caminho eletrônico que
    consta
    o documento
    que está disponibilizado digitalmente para consulta a qualquer momento
    (https://www.aig.com.br/condicoes-gerais) e, assim,
    autorizo a emissão do Bilhete de Seguro.
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b><u>Pessoa Politicamente Exposta</u></b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    Se na aceitação do risco for constatado que o segurado e/ou participante deste seguro está
    classificado
    como Pessoa
    Politicamente Exposta (conforme estabelecido na Circular SUSEP 612/2020), a seguradora reserva-se o
    direito de solicitar
    informações complementares em formulário padrão e documentos comprobatórios. Em casos específicos, a
    seguradora
    poderá solicitar documentação adicional sobre os principais administradores e procuradores da
    companhia
    a fim de garantir
    o devido cumprimento da referida circular.
    <br>
    1. Circular SUSEP 612/2020 - Art. 4º Para fins desta Circular, consideram-se expostas politicamente
    as
    pessoas naturais
    que ocupem ou tenham ocupado, nos 5 (cinco) anos anteriores, empregos ou funções públicas
    relevantes,
    assim como
    funções relevantes em organizações internacionais.
    <br>
    2. Formulário padrão poderá ser solicitado através do e-mail: csgservices&#64;aig.com
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    <b><u>Termos e Condições</u></b>
  </span>
  <br>
  <br>
  <span class="client-data-field-text">
    Ao fornecer suas informações pessoais neste formulário, você concorda e confirma, nos termos da Lei
    13.709/2019, o seu
    consentimento para a coleta, tratamento, utilização e compartilhamento de suas informações pessoais
    pela
    American
    International Group, Inc. (AIG), ou qualquer de suas subsidiárias e afiliadas, para seus prestadores
    de
    serviços,
    resseguradores e representantes de seguros que estejam diretamente relacionados à oferta do seu
    Bilhete
    de Seguro de
    Garantia Estendida Reduzida, bem como em caso de regulação de sinistro e também de outra forma
    estabelecida nas suas
    políticas de privacidade. Se você incluir informações pessoais de terceiros, você confirma ter
    autorização e que informou a
    esta pessoa como a AIG usará essas informações nos termos descritos acima.
    <br><br>
    Declara ter ciência de que poderá exercer os seus direitos de confirmação de existência de
    tratamento;
    acesso aos dados;
    correção; anonimização, dentre outros, através do Serviço de Atendimento ao Cliente – Fale com a
    AIG,
    incluindo, junto de
    seu pedido, as seguintes informações: nome completo, tipo e número de documento de identificação,
    número
    do bilhete do
    seguro, telefone para contato, e e-mail.
  </span>
</div>
